export * from './atoms';
export * from './molecules';
export * from './messages';

import { ProjectAtoms } from './atoms';
import { ProjectMolecules } from './molecules';
import { ProjectMessageComponents  } from './messages';

export const ProjectComponents = [
    ...ProjectAtoms,
    ...ProjectMolecules,
    ...ProjectMessageComponents
];

export const ProjectServices = [
];